export const WEATHER_API_URL = "https://api.openweathermap.org/data/2.5";

export const WEATHER_API_KEY = "8890dff122339fa3d3712c2559dc1f6f";
